<div class="hs-vector-layer-legend" [innerHtml]="svg"></div>